import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

function ResultadoModal({ open, onClose, resultado }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{resultado.status === 'success' ? 'Éxito' : 'Error'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {resultado.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ResultadoModal;